export { default as NewsPaginationItem } from './NewsPaginationItem';
